import React from 'react'
import { useTranslation } from 'react-i18next'

import { CardTemplate } from '../../../../components/CardTemplate'
import { PanelContainer } from '../../../../components/Panel'
import { useConfigContext } from '../../../ui-config'
import { useDeliveryForecastDespatchAdviceById } from '../../data'

type Props = {
  despatchAdviceId: string
}

export const Header: React.FC<Props> = ({ despatchAdviceId }) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()
  const { data, isLoading } =
    useDeliveryForecastDespatchAdviceById(despatchAdviceId)

  const newShippingInformation = {
    ...data?.Payload.ShippingInformation,
    Plant: data?.Payload.Plant,
    UnloadingPoint: data?.Payload.UnloadingPoint,
  }

  return (
    <PanelContainer
      header={t('deliveryForecastDespatchAdvice.header.title')}
      id="delivery-forecast-despatch-advice-header"
      visible={config.deliveryForecastDespatchAdvice.header.enabled}
    >
      <div className="grid">
        {/* buyer */}
        <CardTemplate
          title={t(
            'deliveryForecastDespatchAdvice.header.buyerInformation.title',
          )}
          data={data?.Payload.BuyerInformation}
          config={config.deliveryForecastDespatchAdvice.header.buyerInformation}
          isLoading={isLoading}
        />

        {/* seller */}
        <CardTemplate
          title={t(
            'deliveryForecastDespatchAdvice.header.sellerInformation.title',
          )}
          data={data?.Payload.SellerInformation}
          config={
            config.deliveryForecastDespatchAdvice.header.sellerInformation
          }
          isLoading={isLoading}
        />

        {/* shipping */}
        <CardTemplate
          title={t(
            'deliveryForecastDespatchAdvice.header.shippingInformation.title',
          )}
          data={newShippingInformation}
          config={
            config.deliveryForecastDespatchAdvice.header.shippingInformation
          }
          isLoading={isLoading}
        />
      </div>
    </PanelContainer>
  )
}
